export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fd555ebc231db7e7ea4c1819bc130ae3fe0146daa&name=fetchTypeahead!'